<template>
  <form :class="isLogin ? 'Form is-login' : 'Form'" name="form" ref="form" @submit.prevent>
    <transition-group class="Form__transition-group" name="u-anim-fade-delayed" tag="div">

      <div class="Form__container" key="success" v-if="success" ref="formSuccess">
        <div class="Form__section Form__section--success">

          <div v-if="showConfirmation" class="Form__section-inner">
            <TitleComponent class="Form__confirmationTitle" :level="2" :id="confirmationTitle">{{ confirmationTitle }}</TitleComponent>
            <RichText :content="confirmationText" />

            <p v-if="showNewsletterSignup && formState['Newsletter']"><br><br>{{ options.newsletter_signup_confirmation_text }}</p>
          </div>

          <Form
            v-if="showFeedbackForm && feedbackForm"
            name="feedbackForm"
            :formFields="feedbackForm.form_fields"
            :buttonText="feedbackForm.button_text"
            :formEndpoint="feedbackForm.form_endpoint"
            :showConfirmation="feedbackForm.show_confirmation"
            :confirmationTitle="feedbackForm.confirmation_title"
            :confirmationText="feedbackForm.confirmation_text"
            :gdpr="false"
            :showNewsletterSignup="false"
            :showFeedbackForm="false"
            :feedbackForm="false"
          />

        </div>
      </div>

      <div class="Form__container" key="else" v-else>

        <div v-for="(field, index) in formFields" :class="`Form__section Form__section--${field.type}`" :key="index">

          <div v-if="field.type === 'description'">
            <div :class="`Form__field-wrapper Form__field-wrapper--${field.type}`">
              <RichText
                v-if="field.type === 'description'"
                :content="field.content"
              />
            </div>
          </div>

          <div v-else-if="field.type === 'street_number'">
            <div class="clearfix">
              <div class="Form__section-inner Form__section-inner--street">
                <FormLabel
                  :label="getStringTranslation('form_street')"
                  cleanLabel="street"
                  :required="field.required"
                />
                <div class="Form__field-wrapper Form__field-wrapper--street">
                  <input
                    class="Form__field Form__field--street"
                    v-model="formState['Strasse']"
                    v-validate="field.required ? constructValidation() : false"
                    type="text"
                    id="street"
                    :name="getStringTranslation('form_street')"
                  />
                </div>
              </div>
              <div class="Form__section-inner Form__section-inner--street-number">
                <FormLabel
                  :label="getStringTranslation('form_number')"
                  cleanLabel="street-number"
                  :required="field.required"
                />
                <div class="Form__field-wrapper Form__field-wrapper--street-number">
                  <input
                    class="Form__field Form__field--street-number"
                    v-model="formState['Strasse Nr']"
                    v-validate="field.required ? constructValidation() : false"
                    type="text"
                    id="street-number"
                    :name="getStringTranslation('form_number')"
                  />
                </div>
              </div>
            </div>

            <span v-show="veeValidateErrors.has(getStringTranslation('form_street'))" class="Form__error">
              {{ veeValidateErrors.first(getStringTranslation('form_street')) }}
            </span>
            <span v-show="veeValidateErrors.has(getStringTranslation('form_number'))" class="Form__error">
              {{ veeValidateErrors.first(getStringTranslation('form_number')) }}
            </span>

          </div>

          <div v-else-if="field.type === 'zip_place'">
            <div class="clearfix">
              <div class="Form__section-inner Form__section-inner--zip">
                <FormLabel
                  :label="getStringTranslation('form_zip')"
                  cleanLabel="zip"
                  :required="field.required"
                />
                <div class="Form__field-wrapper Form__field-wrapper--zip">
                  <input
                    class="Form__field Form__field--zip"
                    v-model="formState['PLZ']"
                    v-validate="field.required ? constructValidation('zip') : false"
                    type="text"
                    id="zip"
                    :name="getStringTranslation('form_zip')"
                  />
                </div>
              </div>
              <div class="Form__section-inner Form__section-inner--place">
                <FormLabel
                  :label="getStringTranslation('form_city')"
                  cleanLabel="place"
                  :required="field.required"
                />
                <div class="Form__field-wrapper Form__field-wrapper--place">
                  <input
                    class="Form__field Form__field--place"
                    v-model="formState['Ort']"
                    v-validate="field.required ? constructValidation() : false"
                    type="text"
                    id="place"
                    :name="getStringTranslation('form_city')"
                  />
                </div>
              </div>
            </div>

            <span v-show="veeValidateErrors.has(getStringTranslation('form_zip'))" class="Form__error">
              {{ veeValidateErrors.first(getStringTranslation('form_zip')) }}
            </span>
            <span v-show="veeValidateErrors.has(getStringTranslation('form_city'))" class="Form__error">
              {{ veeValidateErrors.first(getStringTranslation('form_city')) }}
            </span>

          </div>

          <div v-else-if="field.type === 'swiss_only'" >
              <FormLabel
              label="Land"
              cleanLabel="country"
            />
            <div :class="`Form__field-wrapper Form__field-wrapper--text`">
                <input
                :class="`Form__field Form__field--text`"
                value="Schweiz"
                type="text"
                id="country"
                name="country"
                readonly
                />
            </div>

          </div>

             <div v-else-if="field.type === 'quantity'" >
              <FormLabel
              label="Anzahl *"
              cleanLabel="quantity"
            />
            <div :class="`Form__field-wrapper Form__field-wrapper--text`">
                <input
                :class="`Form__field Form__field--quantity`"
                v-model="formState['Anzahl']"
                type="number"
                min="1"
                id="quantity"
                name="quantity"
                />
            </div>

          </div>

          <div v-else-if="field.type === 'radiogroup'">

            <fieldset class="Form__section-fieldset">
              <legend class="Form__section-legend">
                <TitleComponent class="Form__section-title" :level="4">
                  {{ field.label }}
                  <abbr class="Form__label-required" title="required" v-if="field.required">*</abbr>
                </TitleComponent>
              </legend>

              <div class="Form__section-radio-item" v-for="(option, index) in field.radio_group_options" :key="index">
                <input type="radio"
                  class="Form__section-radio-item-input"
                  v-model="formState['Option']"
                  :name="field.label"
                  :id="`radio-item-${index}`"
                  :value="option.option"
                />
                <label class="Form__label Form__label--radio" :for="`radio-item-${index}`">
                  {{ option.option }}
                </label>
                <div :style="{ clear: 'both' }" />
              </div>
            </fieldset>

          </div>

          <div v-else-if="field.type === 'textarea'">

            <FormLabel
              :label="field.label"
              :cleanLabel="cleanLabel(field.label)"
              :required="field.required"
            />

            <div :class="`Form__field-wrapper Form__field-wrapper--${field.type}`">
              <textarea
                :class="`Form__field Form__field--${field.type}`"
                v-model="formState[field.label]"
                v-validate="field.required ? constructValidation() : false"
                :id="cleanLabel(field.label)"
                :name="field.label"
              />
              <span v-show="veeValidateErrors.has(field.label)" class="Form__error">
                {{ veeValidateErrors.first(field.label) }}
              </span>
            </div>

          </div>

          <div v-else-if="field.type === 'password'">

            <FormLabel
              :label="field.label"
              :cleanLabel="cleanLabel(field.label)"
              :required="field.required"
            />

            <div :class="`Form__field-wrapper Form__field-wrapper--${field.type}`">
              <input
                :class="`Form__field Form__field--${field.type}`"
                v-model="formState[field.type]"
                v-validate="constructValidation(field.type)"
                type="password"
                :id="cleanLabel(field.label)"
                :name="field.label"
              />
              <span v-show="veeValidateErrors.has(field.label)" class="Form__error">
                {{ veeValidateErrors.first(field.label) }}
              </span>
              <span v-show="passwordError" class="Form__error">
                {{ getStringTranslation('error_wrongpassword') }}
              </span>
            </div>

          </div>

          <div v-else-if="field.type === 'checkbox'">
            <div class="Form__field-wrapper Form__field-wrapper--checkbox">
              <input
                class="Form__field--checkbox"
                v-model="formState[field.label]"
                v-validate="field.required ? 'required' : false"
                type="checkbox"
                :id="cleanLabel(field.label)"
                :name="field.label"
              />
              <label class="Form__label--checkbox" :for="cleanLabel(field.label)">
                {{ field.required ? '* ' : ''}}{{ field.label }}
              </label>
              <span v-show="veeValidateErrors.has(field.label)" class="Form__error">
                {{ veeValidateErrors.first(field.label) }}
              </span>
            </div>
          </div>

          <div v-else-if="field.type === 'email'">
            <FormLabel
              :label="field.label"
              :cleanLabel="cleanLabel(field.label)"
              :required="field.required"
            />

            <div :class="`Form__field-wrapper Form__field-wrapper--${field.type}`">
              <input
                :class="`Form__field Form__field--${field.type}`"
                v-model="formState.email"
                v-validate="field.required ? constructValidation(field.type) : false"
                type="text"
                :id="cleanLabel(field.label)"
                :name="field.label"
              />
              <span v-show="veeValidateErrors.has(field.label)" class="Form__error">
                {{ veeValidateErrors.first(field.label) }}
              </span>
            </div>

          </div>

          <div v-else>
            <FormLabel
              :label="field.label"
              :cleanLabel="cleanLabel(field.label)"
              :required="field.required"
            />

            <div :class="`Form__field-wrapper Form__field-wrapper--${field.type}`">
              <input
                :class="`Form__field Form__field--${field.type}`"
                v-model="formState[field.label]"
                v-validate="field.required ? constructValidation(field.type) : false"
                type="text"
                :id="cleanLabel(field.label)"
                :name="field.label"
              />
              <span v-show="veeValidateErrors.has(field.label)" class="Form__error">
                {{ veeValidateErrors.first(field.label) }}
              </span>
            </div>
          </div>

        </div>

        <div
          v-if="showNewsletterSignup && options && options.newsletter_signup_title && options.newsletter_signup_text && options.newsletter_signup_confirmation_text"
          class="Form__section Form__section--gdpr"
        >
          <span>
            {{ options.newsletter_signup_title }}
          </span>

          <div class="Form__field-wrapper Form__field-wrapper--checkbox">
            <input
              class="Form__field--checkbox"
              v-model="formState['Newsletter']"
              type="checkbox"
              :id="'newsletter'"
              :name="'newsletter'"
            />
            <label class="Form__label--checkbox" :for="'newsletter'">
              {{ getStringTranslation('newsletter_signup') }}
            </label>
            <p class="Form__info">
              {{ options.newsletter_signup_text }}
            </p>
          </div>
        </div>

        <div v-if="gdpr && gdpr.gdpr" class="Form__section Form__section--gdpr">
          <span v-if="getStringTranslation('gdpr')" >
            {{ getStringTranslation('gdpr') }} *
          </span>

          <div class="Form__field-wrapper Form__field-wrapper--checkbox">
            <input
              class="Form__field--checkbox"
              v-model="formState['Datenschutz']"
              v-validate="'required'"
              type="checkbox"
              :id="cleanLabel(gdprFieldName)"
              :name="gdprFieldName"
            />
            <label class="Form__label--checkbox" :for="cleanLabel(gdprFieldName)">
              {{ gdpr.gdpr_checkbox_label}}
            </label>
            <span v-if="gdpr.gdpr" class="Form__info" v-html="gdpr.gdpr" />

            <span v-show="veeValidateErrors.has(gdprFieldName)" class="Form__error">
              {{ veeValidateErrors.first(gdprFieldName) }}
            </span>
          </div>
        </div>

        <div class='Form__section'>
          <button class='Form__button' @click="submitHandler">
            <span class='Form__button-inner'>{{ buttonText }}</span>
          </button>
        </div>

      </div>

    </transition-group>
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import merge from 'lodash.merge'
import axios from 'axios'
import checkProtectedPagePassword from 'api/checkProtectedPagePassword'
import Title from 'components/Title'
import RichText from 'components/RichText'
import FormLabel from './FormLabel'
import germanDictionary from 'vee-validate/dist/locale/de'
import englishDictionary from 'vee-validate/dist/locale/en'
const moment = require('moment')
require('moment/locale/de')

export default {
  name: 'Form',
  components: {
    'TitleComponent': Title,
    'RichText': RichText,
    'FormLabel': FormLabel
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: true
    },
    formEndpoint: {
      type: String,
      required: true
    },
    formFields: {
      type: Array,
      required: true
    },
    showConfirmation: {
      type: Boolean
    },
    confirmationTitle: {
      type: String
    },
    confirmationText: {
      type: String
    },
    gdpr: {
      type: Object
    },
    showNewsletterSignup: {
      type: Boolean
    },
    showFeedbackForm: {
      type: Boolean
    },
    feedbackForm: {
      type: Object
    }
  },
  data () {
    return {
      veeValidateDictionary: {
        de: {
          messages: germanDictionary.messages
        },
        en: {
          messages: englishDictionary.messages
        }
      },
      formState: {},
      success: false,
      passwordError: false,
      gdprFieldName: false, // is set via string translation
      customValidations: {
        email: {
          email: true
        },
        numeric: {
          numeric: true
        },
        zip: {
          numeric: true,
          min: 4,
          max: 5
        },
        phone: {
          min: 9
        }
      }
    }
  },
  computed: {
    ...mapState({
      options: state => state.data.data.options
    }),
    ...mapGetters(['currentPage', 'getStringTranslation', 'lang'])
  },
  watch: {
    lang: function () {
      this.$validator.localize(this.lang, this.veeValidateDictionary[this.lang]);
    },
    success: function () {
      // scroll to success notification when transition has completed
      setTimeout(() => {
        window.scrollTo(0, this.$refs.formSuccess.offsetTop - 100)
      }, 500)
    }
  },
  created () {
    this.$validator.localize('de', this.veeValidateDictionary.de);
    this.gdprFieldName = this.getStringTranslation('gdpr')
  },
  mounted () {
    this.$validator.localize(this.lang, this.veeValidateDictionary[this.lang]);

    // Add some required fields
    this.formState.email = ''
  },
  methods: {
    onChangeHandler () {
    },
    submitHandler (e) {
      if (this.isLogin) {
        if (this.formState.password) {
          // console.log('password in form: ' + this.formState.password)
          // this.$store.dispatch('checkProtectedPagePassword', this.formState.password)
          checkProtectedPagePassword({ id: this.currentPage.id, password: this.formState.password })
          .then(response => {
            this.passwordError = false
            this.$store.dispatch('authenticatePage')
          })
          .catch(err => {
            this.passwordError = true
            console.log(err)
          })
        }
      } else {
        // console.log(this.formState)
        this.$validator.validateAll().then((result) => {
          // console.log({result})
          if (result) {
            // Add today's date
            this.formState['Gesendet am'] = moment().format('LLLL')

            const dataToBeSubmitted = { ...this.formState }

            // Delete all fields with false value
            for (const [key, value] of Object.entries(dataToBeSubmitted)) {
              if (value === false) delete dataToBeSubmitted[key]
            }

            // Translate booleans to Ja/Nein
            for (const [key, value] of Object.entries(dataToBeSubmitted)) {
              if (typeof value === 'boolean') dataToBeSubmitted[key] = this.translateBooleanToGerman(value)
            }

            // Delete email field if emtpy
            if (dataToBeSubmitted.email === '') delete dataToBeSubmitted.email

            function sortObjectByList(originalObject, firstFields) {
              let sortedObject = {};

              // Add keys from firstFields if they exist in the original object
              firstFields.forEach(field => {
                if (originalObject.hasOwnProperty(field)) {
                  sortedObject[field] = originalObject[field];
                }
              });

              // Add remaining keys from the original object
              Object.keys(originalObject).forEach(key => {
                if (!sortedObject.hasOwnProperty(key)) {
                  sortedObject[key] = originalObject[key];
                }
              });

              return sortedObject;
            }

            // If present we want to have these items first and the other fields after
            const firstFields = [ 'Gesendet am', 'email', 'Newsletter', 'Datenschutz', 'Vorname', 'Nachname', 'Firma', 'Strasse', 'Strasse Nr', 'PLZ', 'Ort', 'Land', 'Telefon', 'Bemerkung' ]

            for (const [key, value] of Object.entries(dataToBeSubmitted)) {
              if (key.includes('–')) {
                const newKey = key
                  .replaceAll('.–', ' ')
                  .replaceAll('–', '-')
                  .replaceAll('\'', '')
                  .replaceAll(',', ' -')
                  .replaceAll('.', '-')
                  .replaceAll('(', '')
                  .replaceAll(')', '')
                const newKeyNoUmlaute = this.replaceUmlaute(newKey)
                dataToBeSubmitted[newKeyNoUmlaute] = value
                delete dataToBeSubmitted[key]
              }
            }

            // console.log(dataToBeSubmitted)
            const sortedDataToBeSubmitted = sortObjectByList(dataToBeSubmitted, firstFields);
            // console.log(sortedDataToBeSubmitted)



            // axios.post('https://formbucket.com/f/buk_Wyhi4MCaemB8r2KygKkhmdmU', sortedDataToBeSubmitted)
            axios.post(this.formEndpoint, sortedDataToBeSubmitted)
            .then(function (response) {
              // console.log(response)
              this.success = true
            }.bind(this))
            .catch(function (error) {
              console.log(error)
            })
            return
          } else {
            // console.log('Correct the errors!')
            // scroll to the first erroneous element
            const firstErrorElement = document.querySelectorAll(`[name="${this.veeValidateErrors.items[0].field}"]`)
            window.scrollTo(0, firstErrorElement[0].offsetTop - 100)
          }
        })
      }
    },
    constructValidation (type) {
      let validation = {
        required: true
      }
      switch (type) {
        case 'numeric':
          validation = merge(validation, this.customValidations.numeric)
          break
        case 'zip':
          validation = merge(validation, this.customValidations.zip)
          break
        case 'email':
          validation = merge(validation, this.customValidations.email)
          break
        case 'phone':
          validation = merge(validation, this.customValidations.phone)
          break
        default:
          break
      }
      // console.log(type, validation)
      return validation
    },
    cleanLabel (label = '') {
      // First replace umlauts with ae, ue, etc.
      const withoutUmlauts = this.replaceUmlaute(label)
      // Finally slugify
      const slugified = this.slugify(withoutUmlauts)
      return slugified
    },
    translateBooleanToGerman (booleanVal) {
      if (booleanVal) {
        return 'Ja'
      } else {
        return 'Nein'
      }
    },
    replaceUmlaute (str) {
      const umlautMap = {
        '\u00dc': 'UE',
        '\u00c4': 'AE',
        '\u00d6': 'OE',
        '\u00fc': 'ue',
        '\u00e4': 'ae',
        '\u00f6': 'oe',
        '\u00df': 'ss'
      }

      return str
        .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
          const big = umlautMap[a.slice(0, 1)]
          return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1)
        })
        .replace(new RegExp('['+Object.keys(umlautMap).join('|')+']',"g"),
          (a) => umlautMap[a]
        )
    },
    slugify (str) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')

      const slugified = str.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text

      return slugified
    },
  }
}
</script>

<style lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// Form.vue?0f16ff6f